export default __webpack_public_path__ + "static/media/bootstrap.f7b7e10f.png";